/** Пакет приложения покупателя в Google Play; на него же указывает `public/.well-known/assetlinks.json`. */
export const customerAppPackage = 'kz.moneyto.customer_app';

export const googlePlayUrl = `https://play.google.com/store/apps/details?id=${customerAppPackage}`;

// Customer app URL confirmed by the project owner on 2026-10-09.
// The merchant app is a separate product and is not the target of these CTAs.
export const appStores: Record<'googlePlay' | 'appStore', string | null> = {
  googlePlay: googlePlayUrl,
  appStore: null,
};
